import { render } from 'preact'
import { App } from './App'
import './index.css'
import './utils/versionUtils' // Import version manager for automatic update checking
 
render(<App />, document.getElementById('app')) 